module.exports = __webpack_public_path__ + "img/2018华药会现场.d47f16be.jpg";